module.exports = __webpack_public_path__ + "static/media/DEAD.f480c3e2.png";